module.exports = __webpack_public_path__ + "static/media/hexas.21ceea5c.png";